// Global

export const GRAPHQL_PATH = "http://localhost:8000/graphql/";

// Authentication

export const GC_USER_ID = "_user_id";
export const GC_AUTH_TOKEN = "_graphql_auth_token";

// Pagination

export const ITEMS_PER_PAGE = 10;

// Colors

export const hot_colors = {
    red000: "#f77e7e",
    red100: "#f96e65",
    red200: "#e94c4c",
    red300: "#dd2e2e",
    yellow300: "#e7af06",
};

export const cool_colors = {
    green000: "#41d693",
    green100: "#11b584",
    green200: "#009c7b",
    green300: "#026e57",

    purple000: "#7253ed",
};

export const neutral_colors = {
    gray: "gray",
};
